import React from 'react';
// @ts-ignore
import logoGovCO from '../assets/logoGovCO.png';
import logoColombia from '../assets/logo-colombia.svg';
// @ts-ignore
import logoART from '../assets/ART_whiteFont.png';
// @ts-ignore
import lockIcon from '../assets/lock.svg';
// @ts-ignore
import shieldCheck from '../assets/shield-check.svg';
// @ts-ignore
import questionCircle from '../assets/question-circle.svg';

const ICON_WHITE = 'brightness(0) invert(1)';

export const GovFooter: React.FC = () => (
  <footer aria-label="Pie de página institucional">
    {/* Módulo entidad */}
    <div className="bg-[#0a0c46] px-6 md:px-16 py-10">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:divide-x md:divide-white/60 gap-8 md:gap-0">

        {/* Col 1 — Logo ART */}
        <div className="flex items-start md:pr-8 md:w-1/4">
          <img src={logoART} alt="Agencia de Renovación del Territorio" className="w-full h-auto" />
        </div>

        {/* Col 2 — Título sistema */}
        <div className="flex items-start md:px-8 md:w-1/4">
          <div>
            <p className="text-white font-semibold text-sm leading-snug mb-2" style={{ fontFamily: "'Nunito Sans', sans-serif" }}>
              Sistema de Gestión de Conocimiento
            </p>
            <p className="text-white/60 text-xs leading-relaxed" style={{ fontFamily: 'Verdana, Geneva, sans-serif' }}>
              Herramienta institucional para la gestión, consulta y análisis de documentos PQRSD con tecnología de Inteligencia Artificial.
            </p>
          </div>
        </div>

        {/* Col 3 — Links con iconos */}
        <div className="flex flex-col gap-3 md:px-8 md:w-1/4">
          <a href="#" className="flex items-center gap-2 text-white/80 hover:text-white text-xs transition-colors" style={{ fontFamily: 'Verdana, Geneva, sans-serif' }}>
            <img src={lockIcon} alt="" aria-hidden="true" className="w-4 h-4 flex-shrink-0 opacity-80" style={{ filter: ICON_WHITE }} />
            Política de seguridad
          </a>
          <a href="#" className="flex items-center gap-2 text-white/80 hover:text-white text-xs transition-colors" style={{ fontFamily: 'Verdana, Geneva, sans-serif' }}>
            <img src={shieldCheck} alt="" aria-hidden="true" className="w-4 h-4 flex-shrink-0 opacity-80" style={{ filter: ICON_WHITE }} />
            Protección de datos
          </a>
          <a href="#" className="flex items-center gap-2 text-white/80 hover:text-white text-xs transition-colors" style={{ fontFamily: 'Verdana, Geneva, sans-serif' }}>
            <img src={questionCircle} alt="" aria-hidden="true" className="w-4 h-4 flex-shrink-0 opacity-80" style={{ filter: ICON_WHITE }} />
            Ayuda y soporte
          </a>
        </div>

        {/* Col 4 — Copyright */}
        <div className="flex flex-col gap-1 text-white/60 text-xs md:pl-8 md:w-1/4" style={{ fontFamily: 'Verdana, Geneva, sans-serif' }}>
          <p className="text-white/80">© 2024 Agencia de Renovación del Territorio</p>
          <p>Todos los derechos reservados</p>
          <p>Versión 1.0.0</p>
        </div>

      </div>
    </div>

    {/* Módulo cierre */}
    <div className="bg-[#0943B5] px-6 py-4 md:px-16">
      <div className="max-w-6xl mx-auto flex items-center gap-4">
        <a
          href="https://www.gov.co"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GOV.CO - Portal del Estado Colombiano"
          className="focus:outline-none focus:ring-2 focus:ring-white rounded"
        >
          <img src={logoGovCO} alt="GOV.CO" style={{ height: '24px', width: 'auto' }} />
        </a>
        <div className="w-px h-6 bg-white/30" />
        <img src={logoColombia} alt="Colombia CO - Marca País" style={{ height: '36px', width: 'auto' }} />
      </div>
    </div>
  </footer>
);
